import { CdkColumnDef } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { MfaBackupCodesModule } from '@lsq-frontend/fasttrack-shared/features/mfa-backup-codes';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { QRCodeModule } from 'angularx-qrcode';
import { AppCommonModule } from '../app-common.module';
import { RemoveBankAccountModalBodyComponent } from '../supply-chain/bank-accounts/bank-account-modals/remove-bank-account-modal.component';
import { BankAccountsComponent as ScfBankAccountsComponent } from '../supply-chain/bank-accounts/bank-accounts.component';
import { AutomaticFundingComponent } from '../supply-chain/direct/automatic-funding/automatic-funding.component';
import { DocumentsComponent } from './documents/documents.component';
import { MobileSettingsMenuComponent } from './mobile-settings-menu/mobile-settings-menu.component';
import { NotificationPreferencesComponent } from './notification-preferences/notification-preferences.component';
import { ProfileComponent } from './profile/profile.component';
import { ChooseMfaModalComponent } from './profile/two-factor/choose-mfa-modal/choose-mfa-modal.component';
import { EditTotpModalComponent } from './profile/two-factor/edit-totp-modal/edit-totp-modal.component';
import { EditTwoFactorPhoneModalComponent } from './profile/two-factor/edit-two-factor-phone-modal/edit-two-factor-phone-modal.component';
import { EditTwoFactorVerifyModalComponent } from './profile/two-factor/edit-two-factor-verify-modal/edit-two-factor-verify-modal.component';
import { MfaConfirmationModalComponent } from './profile/two-factor/mfa-confirmation-modal.component/mfa-confirmation-modal.component';
import { TwoFactorComponent } from './profile/two-factor/two-factor.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsComponent } from './settings.component';
import { UserInfoCardComponent } from './user-info-card/user-info-card.component';
import { UsersPageComponent } from './users/users-page.component';
import { UsersTableComponent } from './users/users-table/users-table.component';
import { UsersComponent } from './users/users.component';

const components = [
    SettingsComponent,
    ProfileComponent,
    ResetPasswordComponent,
    MobileSettingsMenuComponent,
    UsersComponent,
    UsersTableComponent,
    UsersPageComponent,
    NotificationPreferencesComponent,
    ScfBankAccountsComponent,
    RemoveBankAccountModalBodyComponent,
    AutomaticFundingComponent,
    TwoFactorComponent,
    ChooseMfaModalComponent,
    EditTwoFactorPhoneModalComponent,
    EditTwoFactorVerifyModalComponent,
    UserInfoCardComponent,
    DocumentsComponent,
    EditTotpModalComponent,
    MfaConfirmationModalComponent
];

@NgModule({
    declarations: [...components],
    imports: [
        LsqCommonModule.forChild(),
        AppCommonModule,
        SettingsRoutingModule,
        LsqTablesModule.forChild(),
        QRCodeModule,
        MfaBackupCodesModule
    ],
    exports: [...components],
    providers: [CdkColumnDef]
})
export class SettingsModule {}
